import { SET_TIME } from "../actions/time";
import { utcTimestamp } from "../../utils/time";

export default () => dispatch => {
  dispatch({ type: SET_TIME, payload: utcTimestamp() });
};



// WEBPACK FOOTER //
// ./src/store/epics/updateTime.js